<template>
  <div class="mirco-app-report preview">
      <micro-app
        :name="microName"
        :url="getUrl"
        iframe
        router-mode="native"
        :baseroute="`/${microName}`"
        :data="storeInfo"
        keep-alive
        @datachange="handleDataChange"
      ></micro-app>
  </div>
</template>
<script lang="ts">
import microApp, { EventCenterForMicroApp } from '@micro-zoe/micro-app';
import configEnv from '@/config/user.env';
import { useStore } from 'vuex';
import { computed, defineComponent, nextTick, onMounted, reactive, ref, toRefs, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import eventBus from '@/utils/eventBus';
import { lotsUIEventInstance } from '@annto/ui';
import { logout } from '@/utils/index';
import { handleMicroBigDataTrack } from '@/utils/bigLogData/trackHelper';

declare global {
  interface Window {
    eventCenterForAppNameVite: any;
  }
}
// 因为vite子应用关闭了沙箱，我们需要为子应用appname-vite创建EventCenterForMicroApp对象来实现数据通信
window.eventCenterForAppNameVite = new EventCenterForMicroApp('microPrivacy');

export default defineComponent({
  setup() {
    const storeInfo = ref({});
    const state = reactive({
      router: {},
      user: null,
      authority: null,
      currentTenant: null,
      appId: null,
      appList: null,
      btnPermissions: null,
      path: '',
      query: {},
      applicationCode: null,
    });

    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const microName = 'microPrivacy';

    watch(route, (val) => {
      initPage();
    });

    microApp.getData(microName);

    const getUrl = computed(() => {
      return configEnv.microPrivacyUrl;
    });
    const initPage = () => {
      const routeInfo = microApp.router.current.get(microName);
      if (routeInfo && microApp.router.decode(route.path).includes(microName)) {
        if (`/#${route.path}` !== routeInfo.fullPath) {
          nextTick(() => {
            microApp.router.push({ name: microName, path: `/#${route.fullPath}`, params: route.query || {} });
          });
        }
      }

      state.router = router; // 假设 router 是从 useRouter 获取的
      state.user = store.getters.user; // 从 Vuex 获取用户信息
      state.authority = store.getters.authority;
      state.currentTenant = store.getters.currentTenant;
      state.appId = store.getters.appId;
      state.appList = store.getters.appList;
      state.btnPermissions = store.getters.btnPermissions;
      state.applicationCode = store.getters.applicationCode;
      state.path = route.path;
      state.query = route.query;

      const { user, authority, currentTenant, appId, appList, btnPermissions, path, query,  applicationCode } = toRefs(state);
      // 这里的一些参数除了重点说明的两个一般物流的项目都会有;
      storeInfo.value = {
        type: 'updateData',
        router,
        user,
        authority,
        currentTenant,
        appId,
        appList,
        btnPermissions,
        path,
        query,
        applicationCode,
        lotsUIEventInstance,
      };
    };
    const handleDataChange = (val: any) => {
      const data = val.detail.data;
      if (handleMicroBigDataTrack(data, route.path)) return;
      // 子应用可以通过这个函数关闭当前页面
      if (data.type === 'closeActiveView') {
        const { view } = data;
        const findView = store.getters.visitedViews.find((item: any) => {
          return item.href === view.href;
          // return item.href.replace('#', '') === view.fullPath;
        });
        if (findView && findView.fullPath) {
          store.dispatch('delView', findView);
        }
      } else if (data.type === 'routes') {
        const { routes, lang } = data;
        store.commit('updateMicroRoutes', { microName, routes, lang });
        store.commit('UPDATE_VISITED_TITLE');
      } else if (data.type === 'logout') {
        logout();
      }
    };

    // 监听关闭标签事件
    const closeSelectedTag = (view: any) => {
      microApp.setData(microName, { type: 'closeSelectedTag', view });
    };
    eventBus.$on('closeSelectedTag', closeSelectedTag);

    onMounted(() => {
      // 记得修改子应用 id
      // microApp.setData(microName, { path: route.path, query: route.query || {} });
      initPage();
    });

    return {
      microName,
      storeInfo,
      getUrl,
      handleDataChange,
    };
  },
});
</script>
<style lang="less">
.mirco-app-report {
  micro-app[name='microPrivacy'] {
    .app-wrap {
      .app-main {
        padding-top: 0;
      }
    }
  }
}
// .mirco-app-report {
//   height: 100%;

//   micro-app[name='microPrivacy'] {
//     width: 100%;
//     height: 100%;

//     .root-panel {
//       height: 100%;
//     }

//     .privacy-layout .md-button.md-button--primary {
//       background-color: #4285f5;
//       color: #fff;
//       border-color: #409eff;
//     }
//     .privacy-layout .md-button.md-button--text {
//       color: #0077ff;
//     }
//     .md-pagination.is-background .md-pager li:not(.disabled).active {
//       background-color: #4285f5;
//       border: solid 1px #4285f5;
//     }
//   }
// }
</style>
  